import { styles } from "./title";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";


export default function Title({ title, h1 }) {
  
  const router = useRouter();
  const { locale } = router;
  return (
    <Box sx={styles.container} data-aos="fade-up">
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          pb: "20px",
        }}
      >
        <Box sx={styles.title} component={h1 ? h1 : "h2"}>
          {title}
        </Box>

        <Box
          sx={{
            position: "absolute",
            objectFit: "cover",
            // top:"0px",
            width: "100%",
            height: { xs: "6px", lg: "7px" },
            transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
          }}
          component="img"
          alt="image line"
          src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
        ></Box>
      </Box>
    </Box>
  );
}
